<template>
  <div>
    <div class="productsDiv">
      <div class="col-md-12">
        <div
          class="full_heading row text_align_center heading_main heading_style_7 hide_heading_borden_style pageHeader"
        >
          <h2>
            <small>{{ $t("productsTitle1") }}</small
            ><br />{{ $t("productsTitle2") }}
          </h2>
        </div>
      </div>
    </div>
    <div class="container">
      <!-- <div class="currencyDiv">
        <p>{{$t('currencyLabel')}}</p>
        <input type="radio" name="currency" value="EGP" v-model="selectedCurrency" @change="fetchData" />{{ $t('EGP') }}
        <input type="radio" name="currency" value="USD" v-model="selectedCurrency" @change="fetchData" />{{ $t('USD') }}
      </div> -->
      <fieldset>
        <legend>{{ $t("currencyLabel") }}</legend>
        <div class="toggle">
          <input
            type="radio"
            name="currency"
            value="EGP"
            id="EGP"
            checked="checked"
            v-model="selectedCurrency"
            @change="performSearch"
          />
          <label for="EGP">{{ $t("EGP") }}</label>
          <input
            type="radio"
            name="currency"
            value="USD"
            id="USD"
            v-model="selectedCurrency"
            @change="performSearch"
          />
          <label for="USD">{{ $t("USD") }}</label>
        </div>
      </fieldset>
      <!--Filters-->

      <div
        :class="{
          'row container my-5 row-with-margin': langVar === 'ar',
          'en row container my-5 row-with-margin-en': langVar === 'en',
        }"
      >
        <div class="hsidebar-content col-lg-4 col-md-3 col-sm-12 col-xs-12">
          <div class="search-bar">
            <input
              type="text"
              style="
                border: 1px solid lightgray;
                border-radius: 5px;
                padding: 3%;
                width: 100%;
                margin-bottom: 15px;
              "
              placeholder="ما اسم المنتج الذي تبحث عنه في أقسامنا؟"
              v-model="searchKey"
              @input="performSearch"
            />
          </div>
          <!-- <h5 class="filterHeader">{{ $t("filterHeader") }}</h5> -->
          <div class="range-wrapper">
            <label class="filterLabel">{{ $t("price") }}</label
            ><br /><br />
            <div class="price-inputs">
              <input
                type="number"
                v-model="minPriceFilter"
                @input="applyFilters"
                step="1"
                class="form-control"
                :placeholder="$t('minPrice')"
              />
              <span class="priceSeperator">:</span>
              <input
                type="number"
                v-model="maxPriceFilter"
                @input="applyFilters"
                step="1"
                class="form-control"
                :placeholder="$t('maxPrice')"
              />
            </div>
          </div>

          <div class="range-wrapper">
            <label class="filterLabel" for="material">{{
              $t("material")
            }}</label>
            <select
              v-model="materialFilter"
              @change="applyFilters"
              class="form-control"
            >
              <option value="">{{ $t("materialInput") }}</option>
              <option
                v-for="option in materials"
                v-if="option.material"
                :value="option.material.id"
                :key="option.material.id"
              >
                {{ option.material.name }}
              </option>
            </select>
          </div>
          <div class="range-wrapper">
            <label class="filterLabel" for="style">{{ $t("style") }}</label>
            <select
              v-model="styleFilter"
              @change="applyFilters"
              class="form-control"
            >
              <option value="">{{ $t("styleInput") }}</option>
              <option
                v-for="option in styles"
                v-if="option.style"
                :value="option.style"
                :key="option.style"
              >
                {{ option.style }}
              </option>
            </select>
          </div>
          <div class="range-wrapper">
            <label class="filterLabel" for="execute">{{ $t("execute") }}</label>
            <select
              v-model="executeFilter"
              @change="applyFilters"
              class="form-control"
            >
              <option value="">{{ $t("executeInput") }}</option>
              <option
                v-for="option in execute"
                v-if="option.execute"
                :value="option.execute"
                :key="option.execute"
              >
                {{ option.execute }}
              </option>
            </select>
          </div>
          <div class="range-wrapper">
            <label class="filterLabel">{{ $t("sort") }}</label>
            <select v-model="sort" @change="applyFilters" class="form-control">
              <option value="">{{ $t("chooseSort") }}</option>
              <option value="price_asc">{{ $t("priceAsc") }}</option>
              <option value="price_desc">{{ $t("priceDesc") }}</option>
              <option value="earliest">{{ $t("earliest") }}</option>
              <option value="newest">{{ $t("newest") }}</option>
            </select>
          </div>
        </div>
        <!-- Products -->

        <div
          v-if="loading"
          class="spinner-border text-primary"
          role="status"
          style="text-align: center"
        >
          <span class="sr-only">Loading...</span>
        </div>
        <div
          v-else
          v-for="(product, index) in paginatedResults"
          :key="index"
          class="col-lg-4 col-md-6 col-sm-12 col-xs-12"
        >
          <div class="full">
            <div
              :class="{
                product_blog2: langVar === 'ar',
                'product_blog2 product_blog2En': langVar === 'en',
              }"
            >
              <div class="feature_icon">
                <a style="cursor: pointer" @click="productDetails(product)">
                  <vue-load-image>
                    <template v-slot:image>
                      <img
                        :src="product.imagee
                        "
                        :alt="product.title"
                        class="card-img card-img-product"
                      />
                    </template>
                    <template v-slot:preloader>
                      <div
                        class="spinner-border text-primary"
                        role="status"
                        style="text-align: center"
                      >
                        <span class="sr-only">Loading...</span>
                      </div>
                    </template>
                    <template v-slot:error>imagee load fails</template>
                  </vue-load-image>
                </a>
              </div>
              <div class="offerClass" v-if="product.offer">
                <p style="padding-top: 10px">
                  <span class="offerClassSpan2">{{ product.offer }}%</span>
                </p>
              </div>
              <div class="product_title">
                <a style="cursor: pointer" @click="productDetails(product)">
                  <i class="fas fa-info-circle"></i>
                  {{ product.title }}
                </a>
              </div>
              <div v-if="langVar === 'ar'">
                <div :class="{ product_old_price: product.offer }">
                  <span>
                    {{ product.ProductMaterialPrices[0].price }}
                  </span>
                  <span v-if="selectedCurrency == 'USD'">دولار</span>
                  <span v-if="selectedCurrency == 'EGP'">ج.م</span>
                </div>

                <div v-if="product.offer">
                  السعر بعد الخصم:
                  <span style="font-weight: 800"
                    >{{ product.ProductMaterialPrices[0].PriceAfterOffer }}
                    <span v-if="selectedCurrency == 'USD'">دولار</span>
                    <span v-if="selectedCurrency == 'EGP'">ج.م</span></span
                  >
                </div>
              </div>
              <div v-if="langVar === 'en'">
                <div :class="{ product_old_price: product.offer }">
                  {{ product.ProductMaterialPrices[0].price }}
                  {{ selectedCurrency }}
                </div>
                <div v-if="product.offer">
                  Price After Offer:
                  <span style="font-weight: 800"
                    >{{ product.ProductMaterialPrices[0].PriceAfterOffer }}
                    {{ selectedCurrency }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <h2
          v-if="paginatedResults.length == 0 && !loading"
          class="col-lg-4 col-md-6 col-sm-12 col-xs-12"
          style="text-align: center"
        >
          {{ $t("noProducts") }}
        </h2>
      </div>
      <div class="arabic-pagination" v-if="langVar === 'ar'">
        <paginate
          :page-count="pageCount"
          :click-handler="changePage"
          :prev-text="'السابق'"
          :next-text="'القادم'"
          :container-class="'pagination'"
          :page-class="'page-item'"
          :page-link-class="'page-link'"
          :prev-class="'page-item'"
          :prev-link-class="'page-link'"
          :next-class="'page-item'"
          :next-link-class="'page-link'"
        ></paginate>
      </div>
      <div class="arabic-pagination" v-if="langVar === 'en'">
        <paginate
          :page-count="pageCount"
          :click-handler="changePage"
          :prev-text="'Prev'"
          :next-text="'Next'"
          :container-class="'pagination'"
          :page-class="'page-item'"
          :page-link-class="'page-link'"
          :prev-class="'page-item'"
          :prev-link-class="'page-link'"
          :next-class="'page-item'"
          :next-link-class="'page-link'"
        ></paginate>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "../../Axios";
import Paginate from "vuejs-paginate";
import { mapState } from "vuex";
import store from "../../store";
import VueLoadimagee from "vue-load-image";

export default {
  components: {
    paginate: Paginate,
    "vue-load-image": VueLoadimagee,
  },
  data() {
    return {
      searchKey: "",
      loading: false,
      langVar: store.state.currentLang,
      searchResults: [],
      materials: [],
      execute: [],
      styles: [],
      itemsPerPage: 6,
      currentPage: 1,
      minPriceFilter: null,
      maxPriceFilter: null,
      executeFilter: "",
      materialFilter: "",
      styleFilter: "",
      sort: "",
      selectedCurrency: "EGP",
      pagination: {
        currentPage: 1,
        totalPages: 1,
      },
    };
  },
  computed: {
    ...mapState(["currentLang"]),
    currentLang() {
      return store.state.currentLang;
    },
    paginatedResults() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return this.searchResults.slice(startIndex, endIndex);
    },
    pageCount() {
      return Math.ceil(this.searchResults.length / this.itemsPerPage);
    },
  },

  methods: {
    performSearch() {
      this.loading = true;
      if (this.searchKey === "") {
        // Call the same logic as in the mounted method
        this.applyFilters();
        const categoryID = this.$route.query.categoryID;
        let apiUrl = "/products";
        if (categoryID) {
          apiUrl = `/product/category?categoryID=${categoryID}`;
        }
        const apiUrlVar = apiUrl;
        Axios.get(apiUrlVar, {
          headers: {
            currency: this.selectedCurrency,
          },
        })
          .then((response) => {
            if (apiUrlVar.includes("categoryID")) {
              this.searchResults = response.data.products.map((product) => {
                if (
                  product.imagee &&
                  product.imagee.type === "Buffer" &&
                  Array.isArray(product.imagee.data)
                ) {
                  const buffer = Buffer.from(product.imagee.data);
                  const base64imagee = buffer.toString("base64");
                  product.imagee = `data:imagee/jpeg;base64,${base64imagee}`; // Adjust MIME type if needed
                }
                return {
                  icon: product.icon,
                  title: product.name,
                  description: product.description,
                  price: product.price,
                  imagee: product.imagee,
                  offer: product.offer,
                  PriceAfterOffer: product.PriceAfterOffer,
                  id: product.id,
                  ProductMaterialPrices: product.ProductMaterialPrices,
                };
              });
              this.materials = response.data.materials.map((material) => {
                return {
                  material: material,
                };
              });

              this.execute = response.data.execute.map((execute) => {
                return {
                  execute: execute,
                };
              });

              this.styles = response.data.styles.map((style) => {
                return {
                  style: style,
                };
              });
            } else {
              this.searchResults = response.data.products.map((product) => {
                return {
                  icon: product.icon,
                  title: product.name,
                  description: product.multilingualData.description,
                  price: product.multilingualData.price,
                  imagee: product.imagee,
                  offer: product.offer,
                  PriceAfterOffer: product.PriceAfterOffer,
                  id: product.id,
                  ProductMaterialPrices: product.ProductMaterialPrices,
                };
              });
            }
          })
          .catch((error) => {
            // console.log(apiUrlVar, "aaa");
            // console.error(error);
          });
        this.loading = false;
      } else {
        Axios.get(`/products`, {
          params: {
            limit: 6,
            searchkey: this.searchKey,
            page: this.pagination.currentPage,
          },
        })
          .then((response) => {
            // Update table data with search results
            this.searchResults = response.data.products.map((product) => {
              if (
                product.imagee &&
                product.imagee.type === "Buffer" &&
                Array.isArray(product.imagee.data)
              ) {
                const buffer = Buffer.from(product.imagee.data);
                const base64imagee = buffer.toString("base64");
                product.imagee = `data:imagee/jpeg;base64,${base64imagee}`; // Adjust MIME type if needed
              }
              return {
                icon: product.icon,
                title: product.name,
                description: product.description,
                price: product.multilingualData.price,
                imagee: product.imagee,
                offer: product.offer,
                PriceAfterOffer: product.PriceAfterOffer,
                id: product.id,
                ProductMaterialPrices: product.ProductMaterialPrices,
              };
            });
            // Update pagination values based on the response
            this.pagination.currentPage = response.data.currentPage;
            this.pagination.totalPages = response.data.totalPages;
            this.loading = false;
          })
          .catch((error) => {
            this.searchResults = [];
            // console.error(error);
            this.loading = false;
          });
      }
    },
    fetchData() {
      this.loading = true;
      const categoryID = this.$route.query.categoryID;

      let apiUrl = "/products";

      if (categoryID) {
        apiUrl = `/product/category?categoryID=${categoryID}`;
      }

      Axios.get(apiUrl, {
        headers: {
          currency: this.selectedCurrency,
        },
      })
        .then((response) => {
          // console.log(response.data, "bbb");
          this.searchResults = response.data.map((product) => {
            if (
              product.imagee &&
              product.imagee.type === "Buffer" &&
              Array.isArray(product.imagee.data)
            ) {
              const buffer = Buffer.from(product.imagee.data);
              const base64imagee = buffer.toString("base64");
              product.imagee = `data:imagee/jpeg;base64,${base64imagee}`; // Adjust MIME type if needed
            }
            return {
              icon: product.icon,
              title: product.name,
              description: product.description,
              price: product.productMaterialPrices[0].price,
              imagee: product.imagee,
              offer: product.offer,
              PriceAfterOffer: product.PriceAfterOffer,
              id: product.id,
              ProductMaterialPrices: product.ProductMaterialPrices,
            };
          });
          this.loading = false;
        })
        .catch((error) => {
          // console.error(error);
          this.loading = false;
        });
    },
    applyFilters() {
      const searchUrl = `/product/category`;
      const categoryIdVar = this.$route.query.categoryID;

      const params = {
        maxPrice: this.maxPriceFilter,
        minPrice: this.minPriceFilter,
        material: this.materialFilter,
        execute: this.executeFilter,
        style: this.styleFilter,
        categoryID: categoryIdVar,
        sort: this.sort,
      };

      Axios.get(searchUrl, {
        headers: {
          currency: this.selectedCurrency,
        },
        params: params,
      })
        .then((response) => {
          // Process the response as needed
          this.searchResults = response.data.products.map((product) => {
            if (
              product.imagee &&
              product.imagee.type === "Buffer" &&
              Array.isArray(product.imagee.data)
            ) {
              const buffer = Buffer.from(product.imagee.data);
              const base64imagee = buffer.toString("base64");
              product.imagee = `data:imagee/jpeg;base64,${base64imagee}`; // Adjust MIME type if needed
            }
            return {
              icon: product.icon,
              title: product.name,
              description: product.description,
              price: product.price,
              imagee: product.imagee,
              offer: product.offer,
              PriceAfterOffer: product.PriceAfterOffer,
              material: product.material,
              execute: product.execute,
              style: product.style,
              id: product.id,
              ProductMaterialPrices: product.ProductMaterialPrices,
            };
          });
          // console.log(this.searchResults, "bbb");
        })
        .catch((error) => {
          // console.error(error);
          this.searchResults = [];
        });
    },
    changePage(pageNumber) {
      this.currentPage = pageNumber;
    },
    productDetails(product) {
      this.$router.push({
        name: "product-details-web",
        params: { id: product.id },
        props: { productData: product },
      });
    },
  },
  mounted() {
    this.applyFilters();
    const categoryID = this.$route.query.categoryID;
    let apiUrl = "/products";
    if (categoryID) {
      apiUrl = `/product/category?categoryID=${categoryID}`;
    }
    const apiUrlVar = apiUrl;
    Axios.get(apiUrlVar, {
      headers: {
        currency: this.selectedCurrency,
      },
    })
      .then((response) => {
        if (apiUrlVar.includes("categoryID")) {
          this.searchResults = response.data.products.map((product) => {
            if (
              product.imagee &&
              product.imagee.type === "Buffer" &&
              Array.isArray(product.imagee.data)
            ) {
              const buffer = Buffer.from(product.imagee.data);
              const base64imagee = buffer.toString("base64");
              product.imagee = `data:imagee/jpeg;base64,${base64imagee}`; // Adjust MIME type if needed
            }
            return {
              icon: product.icon,
              title: product.name,
              description: product.description,
              price: product.price,
              imagee: product.imagee,
              offer: product.offer,
              PriceAfterOffer: product.PriceAfterOffer,
              id: product.id,
              ProductMaterialPrices: product.ProductMaterialPrices,
            };
          });
          this.materials = response.data.materials.map((material) => {
            return {
              material: material,
            };
          });

          this.execute = response.data.execute.map((execute) => {
            return {
              execute: execute,
            };
          });

          this.styles = response.data.styles.map((style) => {
            return {
              style: style,
            };
          });
        } else {
          this.searchResults = response.data.products.map((product) => {
            return {
              icon: product.icon,
              title: product.name,
              description: product.multilingualData.description,
              price: product.multilingualData.price,
              imagee: product.imagee,
              offer: product.offer,
              PriceAfterOffer: product.PriceAfterOffer,
              id: product.id,
              ProductMaterialPrices: product.ProductMaterialPrices,
            };
          });
        }
      })
      .catch((error) => {
        // console.log(apiUrlVar, "aaa");
        // console.error(error);
      });
  },
};
</script>

<style>
.product_old_price {
  text-decoration: line-through;
}
fieldset {
  text-align: center;
  margin: 0;
  padding: 1rem;
  box-sizing: border-box;
  display: block;
  border: solid 1px #ccc;
  border-radius: 15px;
  min-width: 0;
  background-color: #ffffff5c;
}

fieldset legend {
  margin: 0 0 1.5rem;
  padding: 0;
  width: 100%;
  float: left;
  display: table;
  font-size: 1.5rem;
  line-height: 140%;
  font-weight: 600;
  color: #333;
}

/* TOGGLE STYLING */
.toggle {
  margin: 0 0 1.5rem;
  box-sizing: border-box;
  font-size: 0;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: stretch;
}

.toggle input {
  /* Removed the mixin hideInput properties */
  width: 0;
  height: 0;
  position: absolute;
  left: -9999px;
}

.toggle input + label {
  margin: 0;
  padding: 0.75rem 2rem;
  box-sizing: border-box;
  position: relative;
  display: inline-block;
  border: solid 1px #ddd;
  background-color: #fff;
  font-size: 1rem;
  line-height: 140%;
  font-weight: 600;
  text-align: center;
  box-shadow: 0 0 0 rgba(255, 255, 255, 0);
  transition: border-color 0.15s ease-out, color 0.25s ease-out,
    background-color 0.15s ease-out, box-shadow 0.15s ease-out;
}

.toggle input + label:first-of-type {
  border-right: none;
  border-radius: 0 6px 6px 0;
}

.toggle input + label:last-of-type {
  border-radius: 6px 0 0 6px;

  border-left: none;
}

.toggle input:hover + label {
  border-color: #213140;
}

.toggle input:checked + label {
  background-color: #e2d8ce;
  color: #fff;
  box-shadow: 0 0 10px rgba(#e2d8ce, 0.5);
  border-color: #e2d8ce;
  z-index: 1;
}

.toggle input:focus + label {
  outline: dotted 1px #ccc;
  outline-offset: 0.45rem;
}

/* STYLING FOR THE STATUS HELPER TEXT FOR THE DEMO */
.status {
  margin: 0;
  font-size: 1rem;
  font-weight: 400;
}

.status span {
  font-weight: 600;
  color: #b6985a;
}

.status span:first-of-type {
  display: inline;
}

.status span:last-of-type {
  display: none;
}

body {
  background-color: #f3f1f0;
}
.pageHeader {
  background-imagee: url(../../assets/images/background.png);
  background-size: cover;
  height: 220px;
  padding-top: 15px;
  padding-bottom: 15px;
  text-align: center;
  max-width: 100%;
}
.pageHeader > h2 {
  margin-top: 80px;
}
.product_blog2 {
  background: #ffffffb8;
  float: left;
  margin: 15px 0;
  position: relative;
  overflow: hidden;
  box-shadow: 0 20px 30px -30px #000;
  text-align: center;
  height: 400px;
  border-radius: 15px;
  transition: background-color 2s ease;
  line-height: 30px;
}

.product_blog2:before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 40px 40px 0;
  border-color: transparent #e2d8ce transparent transparent;
  z-index: 10;
}
.card-img-product {
  width: 100%;
  min-width: 330px;
  max-height: 250px;
  margin-bottom: 15px;
}
.card-img-product:hover {
  animation: zoomInOut 2s ease-in-out;
}

@keyframes zoomInOut {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05); /* Adjust the scale factor as needed for zoom-in */
  }
}

.offerClass {
  border-bottom-left-radius: 5px;
  position: absolute;
  top: 0%;
  background-color: #e2d8ceee;
  padding: 0px 10px;
  font-size: 14px;
  color: #605c59;
  font-weight: 800;
  z-index: 11;
}
.smallText {
  font-size: 12px;
  margin-top: -15px;
  margin-bottom: 3px;
}
.offerClassSpan2 {
  color: rgb(221, 45, 45);
  font-size: 18px;
  font-weight: 800;
  padding: 10%;
  text-shadow: 0 2px 2px rgb(67, 66, 66);
}
.product_details {
  padding: 15px;
  text-align: center;
  border-radius: 0 0 15px 15px;
}
.product_title {
  font-size: 18px;
  font-weight: bold;
  margin: 10px 0;
}

.img-hover-zoom {
  height: 300px;
  overflow: hidden;
}

/*Filters*/
/*
.filterHeader {
  margin-top: 15px;
  margin-bottom: 35px;
  font-weight: 500;
  color: gray;
}*/
.filterHeader {
  margin-top: 5px;
  margin-bottom: 10px;
  font-weight: 500;
  color: gray;
}
.hsidebar-content {
  background-color: #fcfbfb;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
  font-size: 14px;
  max-width: 95%;
  text-align: center;
}

.hsidebar-content:hover {
  background-color: white;
}

.list-title {
  font-size: 18px;
  margin-bottom: 15px;
}

.range-slider-style2 {
  margin-bottom: 20px;
}

.range-wrapper {
  margin-bottom: 15px;
}

.d-flex {
  display: flex;
}

.selection {
  margin-right: 10px;
  background-color: #ffffff;
  border: 2px solid transparent;
  cursor: pointer;
  display: inline-block;
  font-weight: 600;
  font-size: 13px;
  outline: 1px solid #dddddd;
  padding: 7px 12px;
}

.selection input[type="radio"] {
  appearance: none;
}

.btn-area {
  margin-top: 20px;
}

.ud-btn {
  display: inline-block;
  padding: 10px 20px;
  background-color: #eb6753;
  color: #fff;
  border-radius: 5px;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
}

.ud-btn:hover {
  background-color: #eb6753c5;
}

.reset-area {
  margin-top: 20px;
}

.reset-button {
  display: inline-block;
  color: #999;
  text-decoration: none;
  font-size: 14px;
  line-height: 1;
  transition: color 0.3s ease;
}

.reset-button:hover {
  color: #666;
}

.reset-button u {
  margin-left: 5px;
}
.requestedSpan {
  padding: 5px;
  color: darkred;
  border: 1px solid darkred;
  border-radius: 10px;
}

.updateBtn {
  margin-top: -30px;
  margin-left: 55px;
}

.details {
  font-size: 16px;
  font-weight: 300;
  margin-left: -1px;
}

.price-inputs {
  display: flex;
}

.price-inputs input {
  width: 25%;
  display: block;
  text-align: center;
  margin-right: 10px;
}

.priceSeperator {
  font-size: 28px;
  margin-right: 3%;
  color: gray;
}
/*
.filterLabel {
  margin-top: 10px;
}
*/
.row-with-margin
  > [class*="col-"]:not(:nth-child(-n + 3)):not(:nth-child(odd)) {
  margin-right: 33.33%;
}

.row-with-margin-en
  > [class*="col-"]:not(:nth-child(-n + 3)):not(:nth-child(odd)) {
  margin-left: 33.33%;
}

/*Pagination*/

/* Arabic Pagination Styles */
.pagination {
  margin-top: 20px;
  text-align: center;
  font-size: 16px;
}

.page-item {
  display: inline-block;
  margin: 0 5px;
}

.page-link {
  padding: 8px 16px;
  border: 1px solid #ccc;
  background-color: #f8f8f8;
  color: #333;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.page-link:hover {
  background-color: #ddd;
}

.page-item.active .page-link {
  background-color: #007bff;
  color: #fff;
  border-color: #007bff;
}

.page-item.disabled .page-link {
  background-color: #f8f8f8;
  color: #ccc;
  cursor: not-allowed;
  border-color: #ccc;
}

.page-item:first-child .page-link,
.page-item:last-child .page-link {
  border-radius: 0;
}

/* Arabic Pagination Text Direction */
.arabic-pagination {
  direction: rtl;
  margin-right: 54%;
  margin-top: 30px;
}

/* Arabic Pagination Alignment */
.arabic-pagination .page-item {
  display: inline-block;
  margin: 0 5px;
}

.arabic-pagination .page-link {
  padding: 8px 16px;
  border: 1px solid #ccc;
  background-color: #f8f8f8;
  color: #333;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.arabic-pagination .page-link:hover {
  background-color: #ddd;
}

.arabic-pagination .page-item.active .page-link {
  background-color: #b5aaa3;
  color: #fff;
  border-color: #948c87;
}

.arabic-pagination .page-item.disabled .page-link {
  background-color: #f8f8f8;
  color: #ccc;
  cursor: not-allowed;
  border-color: #ccc;
}

.arabic-pagination .page-item:first-child .page-link,
.arabic-pagination .page-item:last-child .page-link {
  border-radius: 0;
}

@media (max-width: 1200px) {
  .product_blog2 {
    float: none;
  }
  .card-img-product {
    min-width: auto;
  }
}
@media (max-width: 990px) {
  .hsidebar-content {
    width: 100%;
  }

  .row-with-margin-en
    > [class*="col-"]:not(:nth-child(-n + 3)):not(:nth-child(odd)) {
    margin-left: 0;
  }
  .row-with-margin
    > [class*="col-"]:not(:nth-child(-n + 3)):not(:nth-child(odd)) {
    margin-right: 0;
  }
}

@media (max-width: 800px) {
  .hsidebar-content {
    width: 100%;
  }
  .arabic-pagination .page-item,
  .arabic-pagination {
    margin: 0;
  }
}
</style>